module.exports = __webpack_public_path__ + "img/unsync.1ab32a7f.svg";